import { useTranslation } from "react-i18next";
import LegalContent from "./LegalContent";
import SEO from "../app/SEO";

export default function TermsOfService() {
    const { t } = useTranslation("legal");
    const sections: any[] = t("policies.terms.sections", { returnObjects: true });

    return (
        <>
            <SEO title={{ title: t("policies.terms.fullTitle"), pageTitle: t("policies.terms.fullTitle") }} canonicalPath="/legal/terms" />
            <LegalContent
                title={t("policies.terms.title")}
                subtitle={t("policies.terms.subtitle")}
                updated={t("lblUpdated", { date: t("policies.terms.updated") })}
                sections={sections} />
        </>
    );
}